// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateGenericEventMutationVariables = Types.Exact<{
  data: Types.CreateGenericEventInput;
}>;


export type CreateGenericEventMutation = { __typename?: 'Mutation', createGenericEvent: { __typename?: 'GenericEvent', id: string } };


export const CreateGenericEventDocument = gql`
    mutation createGenericEvent($data: CreateGenericEventInput!) {
  createGenericEvent(data: $data) {
    id
  }
}
    `;
export type CreateGenericEventMutationFn = Apollo.MutationFunction<CreateGenericEventMutation, CreateGenericEventMutationVariables>;

/**
 * __useCreateGenericEventMutation__
 *
 * To run a mutation, you first call `useCreateGenericEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericEventMutation, { data, loading, error }] = useCreateGenericEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGenericEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericEventMutation, CreateGenericEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericEventMutation, CreateGenericEventMutationVariables>(CreateGenericEventDocument, options);
      }
export type CreateGenericEventMutationHookResult = ReturnType<typeof useCreateGenericEventMutation>;
export type CreateGenericEventMutationResult = Apollo.MutationResult<CreateGenericEventMutation>;
export type CreateGenericEventMutationOptions = Apollo.BaseMutationOptions<CreateGenericEventMutation, CreateGenericEventMutationVariables>;